// extracted by mini-css-extract-plugin
export default {"container":"works_container__C4MDB","container_small":"works_container_small__+sZYm","container-lg":"works_container-lg__7NoU+","main":"works_main__7PHL6"};